import type { StatusBadgeVariant } from "@/components/ui/status-badge";
import type { GameCardProps } from "@/components/layout/GameCard";

export const VIP_ACCESS_LABEL = "Acesso VIP";

export const VIP_ACCESS_BADGE: { label: string; variant: StatusBadgeVariant } = {
  label: VIP_ACCESS_LABEL,
  variant: "success",
};

export function buildCardCountdown(
  target: Date,
  now = new Date(),
): GameCardProps["countdown"] | undefined {
  const diff = target.getTime() - now.getTime();
  if (diff <= 0) return undefined;

  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

  if (days === 0 && hours === 0 && minutes === 0) {
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);
    return { days, hours, minutes, seconds };
  }

  return { days, hours, minutes };
}
